import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import {HelpOutline} from '@mui/icons-material';
import { DialogType, GenericDialog } from '../../../dialog/GenericDialog';

/**
 * Render a generic title. 
 * It's used inside step but can be used in other places
 */
export const GenericFormTitle: React.FC<ITitle> = (props: ITitle): JSX.Element => {

    const [ openDialog, setOpenDialog ] = useState<boolean>(false);
    const handleClose = ():void => setOpenDialog(false)

    const renderDialog = () : React.ReactChild | null => {
        if (!props.tooltip) return null
        return (
            <GenericDialog
                open={openDialog}
                dialog={props.tooltip}
                onClose={handleClose}
                />
        )
    }

    return (
        <div className={`step-title ${props.className}`}>
            { props.title && <h3>{ props.title }</h3>}
            { props.subTitle && <h1>{props.subTitle}</h1> }
    
            {
                props.tooltip && 
                <div className="step-tooltip">
                    <IconButton onClick={() => setOpenDialog(true)}>
                        <HelpOutline />
                    </IconButton>
                </div>
            }
    
            { props.description && <p>{ props.description }</p> }

            { openDialog && renderDialog() }
        </div>
    );
}
 

export type ITitle = {
    className?: string, 
    title?: string,
    subTitle?: string,
    description?: string,
    tooltip?: DialogType
}
